<template>
  <b-row v-if="reqItem" class="request-details-modern">
    <b-col cols="12">
      <div class="request-meta-card">
        <div class="meta-row">
          <div class="meta-item">
            <span class="meta-label">Request Type</span>
            <b-badge variant="light-primary" class="meta-badge text-capitalize">
              {{ reqItem.requestCategory }}
            </b-badge>
          </div>
          <div class="meta-item">
            <span class="meta-label">Requested On</span>
            <b-badge variant="light-primary" class="meta-badge">
              {{
                new Date(reqItem.requestedOn).toLocaleDateString("en-UK", {
                  year: "numeric",
                  day: "numeric",
                  month: "short",
                })
              }}
            </b-badge>
          </div>
          <div class="meta-item">
            <span class="meta-label">Status</span>
            <b-badge :variant="getVariant" class="meta-badge text-capitalize">
              {{ reqItem.status }}
            </b-badge>
          </div>
        </div>
      </div>
    </b-col>

    <b-col cols="12">
      <div class="details-section">
        <label class="details-label">Reason</label>
        <div class="details-box">
          <p class="details-text">
            {{ reqItem.request || "No reason provided" }}
          </p>
        </div>
      </div>
    </b-col>

    <b-col cols="12" v-if="reqItem.status != 'pending' && reqItem.note">
      <div class="details-section">
        <label class="details-label">Note</label>
        <div class="details-box">
          <p class="details-text">
            {{ reqItem.note }}
          </p>
        </div>
      </div>
    </b-col>

    <!-- documents -->
    <b-col cols="12" v-if="docList.length > 0">
      <div class="details-section">
        <label class="details-label">Attachments</label>
        <div class="d-flex flex-wrap mt-1">
          <div
            class="border-dashed d-flex flex-column justify-content-center align-items-center cursor-pointer rounded mr-50 mb-1 bg-light"
            style="width: 100px; height: 90px; position: relative"
            v-for="(file, index) in docList"
            :key="index"
            @click="openFile(file)"
          >
            <feather-icon
              :icon="isImage(file) ? 'ImageIcon' : 'FileTextIcon'"
              size="30"
              class="text-primary"
            />
          </div>
        </div>
      </div>
    </b-col>
  </b-row>
</template>
<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BBadge,
  VBTooltip,
  BFormCheckbox,
  BFormGroup,
  BForm,
  BMediaAside,
  BSpinner,
  BSidebar,
  BInputGroup,
  BFormTextarea,
} from "bootstrap-vue";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BBadge,
    BFormCheckbox,
    BFormGroup,
    BForm,
    BMediaAside,
    BSpinner,
    BSidebar,
    BInputGroup,
    BFormTextarea,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  props: {
    reqItem: {
      type: Object,
      default: null,
    },
  },
  computed: {
    getVariant() {
      if (this.reqItem.status == "accepted") return "success";
      else return "danger";
    },
    docList() {
      if (this.reqItem.attachment) return this.reqItem.attachment.split(",");
      else return [];
    },
    appDocs() {
      if (this.reqItem.approved_document)
        return this.reqItem.approved_document.split(",");
      else return [];
    },
  },
  methods: {
    isImage(url) {
      return /\.(jpg|jpeg|png|webp|avif|gif|svg)$/i.test(url);
    },
    openFile(url) {
      window.open(url, "_blank");
    },
  },
};
</script>
<style scoped>
.request-details-modern {
  margin-top: 0.75rem;
}

.request-meta-card {
  background: linear-gradient(135deg, #f9fafb 0%, #f3f4ff 50%, #eef2ff 100%);
  border-radius: 14px;
  padding: 0.9rem 1.1rem;
  border: 1px solid #e0e7ff;
  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.08);
}

.meta-row {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem 1.5rem;
}

.meta-item {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.meta-label {
  font-size: 0.82rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #6b7280;
  margin-bottom: 0.2rem;
  font-weight: 600;
}

.meta-badge {
  padding: 0.3rem 0.9rem;
  border-radius: 999px;
  font-size: 0.88rem;
  font-weight: 700;
}

.details-section {
  margin-top: 1rem;
}

.details-label {
  display: block;
  font-size: 0.88rem;
  font-weight: 600;
  color: #4b5563;
  margin-bottom: 0.35rem;
}

.details-box {
  background: #f9fafb;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  padding: 0.75rem 0.9rem;
  min-height: 80px;
}

.details-text {
  margin: 0;
  font-size: 0.9rem;
  color: #111827;
  white-space: pre-wrap;
}

@media (max-width: 576px) {
  .request-meta-card {
    padding: 0.75rem;
  }
  .meta-row {
    flex-direction: column;
  }
}
</style>
